<script setup lang="ts">
import {ElButton, ElMessage} from 'element-plus';
import {downloadFile} from '@/base/utils.js';
import {ref} from 'vue';
import {exportReportItemsForReporter} from '@/base/callBackend.js';
import {generateDateId} from 'common/index.js';

const downloading = ref<boolean>(false);

async function doDownloadReportingItemsExcel() {
    downloading.value = true;
    const response    = await exportReportItemsForReporter();
    if (response.ok) {
        await downloadFile(response, `zzc-${generateDateId()}.xlsx`);
    } else {
        const data = await new Response(response.body).json();
        ElMessage({
            message: `Failed: ${data.message}`,
            type   : 'error',
        });
    }
    downloading.value = false;
}

</script>

<template>
    <div class="flex justify-center items-center mt-32">
        <div class="flex flex-col space-y-4">
            <div class="flex flex-col space-y-4 justify-center items-center p-5 border-transparent border-2">
                <el-button type="primary" size="large"
                           @click="doDownloadReportingItemsExcel()"
                           :disabled="downloading"
                           :loading="downloading"
                           class="w-80"
                >
                    Download Excel File met Rapportages
                </el-button>
            </div>
        </div>
    </div>
</template>
